module.exports = __webpack_public_path__ + "img/tvnow-card-header.f6873815.jpg";